<template>
  <div class="body1">
    <div class="content content1">
      <div class="title">WHAT ARE THE TYPES OF FRANCHISE MODELS AVAILABLE?</div>
      <div class="des">Single Unit Franchise</div>
      <div class="des">Multi-Unit/Area Franchise</div>
      <div class="des">Master Franchise</div>
      <div class="des">Curriculum licensing</div>
    </div>
    <div class="content content2">
      <div class="big-tit title">WHY FRANCHISE WITH US</div>
    </div>
    <div class="content content3">
      <div class="item">
        <img class="img" src="../../assets/franchise-05.png">
        <div class="title">Course<br/>Localization</div>
      </div>
      <div class="item">
        <img class="img" src="../../assets/franchise-06.png">
        <div class="title">Professional<br/>corporate<br/>image</div>
      </div>
      <div class="item">
        <img class="img" src="../../assets/franchise-07.png">
        <div class="title">Proven business<br/>konw-how and<br/>system</div>
      </div>
      <div class="item">
        <img class="img" src="../../assets/franchise-08.png">
        <div class="title">Digital<br/>management<br/>system</div>
      </div>
      <div class="item">
        <img class="img" src="../../assets/franchise-09.png">
        <div class="title">Training and<br/>support </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .content{
    .media-content;
    max-width: 1000px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    .item{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 174px;
      .img{
        width: 102px;
        object-fit: contain;
        height: 102px;
        margin-bottom: 60px;
      }
    }

    .title{
      text-align: center;
      color: #6D43A1;
      font-size: 18px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      font-weight: bold;
    }
    .big-tit{
      font-size: 40px;
      margin-bottom: 82px;
    }
  }
  .content1{
    display: block;
    overflow: hidden;
    text-align: center;
    border-radius: 8px;
    margin: 65px 0 120px;
    background: rgba(109, 67, 161, 0.1);
    .title{
      width: 100%;
      line-height: 72px;
      color: #fff;
      font-size: 26px;
      font-weight: bold;
      background: #6D43A1;
    }
    .des{
      color: #6D43A1;
      font-size: 22px;
      // font-weight: bold;
      line-height: 56px;
      border-bottom: 2px solid #fff;
    }
  }
  .content3{
    margin-bottom: 120px;
    padding: 0 30px;
    box-sizing: border-box;
    .title{
      height: 90px;
      color: #030303;
      font-size: 22px;
      font-weight: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/franchise/e-body2.vue